import React from 'react';

interface PenaltyModalProps {
  open: boolean;
  players: any[];
  side: 'US' | 'THEM' | null;
  onSelectPenaltyPlayer: (number: number) => void;
  onClose: () => void;
  onDone: () => void;
  selectedPlayers?: number[];
  onTeamStat?: () => void;
  submitting?: boolean;
}

const PenaltyModal: React.FC<PenaltyModalProps> = ({
  open,
  players,
  side,
  onSelectPenaltyPlayer,
  onClose,
  onDone,
  selectedPlayers = [],
  onTeamStat,
  submitting = false,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white shadow-lg p-0 flex flex-col items-center w-full h-[100vh]">
        <div className="relative w-full h-[120px] flex items-center justify-center overflow-hidden">
          <img
            src="/images/goal-modal-header.png"
            alt="goal"
            className="absolute top-0 left-0 w-full h-full object-cover z-[1]"
          />
          <p className="relative text-center italic font-black text-[40px] md:text-[45px] lg:text-[54px] text-[#19133c] z-20 text-stroke-green">
            {side === 'US' ? 'PENALTY US' : side === 'THEM' ? 'THEM PENALTY' : 'PENALTY'}
          </p>
        </div>
        <div className="w-full flex flex-col items-center px-4 pt-4 pb-6 overflow-y-auto">
          <p className="text-xl font-bold text-start text-[#19133c] mb-3 w-full">On whom was the penalty attributed?</p>
          <div className="grid grid-cols-5 gap-5 mb-6 w-full">
            {players.map((player: any, idx: number) => (
              <div
                className={`flex flex-col justify-start items-center ${submitting ? 'opacity-60' : ''}`}
                key={idx}
                onClick={() => {
                  if (submitting) return;
                  onSelectPenaltyPlayer(player.no);
                }}
              >
                <button
                  key={player.no}
                  disabled={submitting}
                  className={`flex flex-col items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full font-semibold text-white text-base shadow transition-all duration-150
                    ${
                      selectedPlayers.includes(player.no)
                        ? 'bg-[#fff59d] text-black border-2 border-yellow-400'
                        : 'bg-[#19133c]'
                    } ${submitting ? 'cursor-not-allowed opacity-70' : ''}
                  `}
                >
                  <span className="text-[26px]">{player.no}</span>
                </button>
                <p
                  className="w-full text-sm font-semibold leading-tight text-center px-0.5 min-h-[2.5em]"
                  title={`${player.firstName} ${player.lastName}`}
                >
                  <span className="block truncate">{player.firstName}</span>
                  <span className="block truncate">{player.lastName}</span>
                </p>
              </div>
            ))}

            {side === 'US' && onTeamStat && (
              <div
                className={`flex flex-col justify-start items-center ${submitting ? 'opacity-60' : ''}`}
                onClick={() => {
                  if (submitting) return;
                  if (onTeamStat) {
                    onTeamStat();
                  }
                }}
              >
                <button
                  disabled={submitting}
                  className={`flex flex-col items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full font-semibold text-white text-base shadow transition-all duration-150 bg-[#ff6b35] ${
                    submitting ? 'cursor-not-allowed opacity-70' : ''
                  }`}
                >
                  <span className="text-[26px]">T</span>
                </button>
                <p className="w-full text-sm font-semibold leading-tight text-center px-0.5 min-h-[2.5em]">
                  <span className="block truncate">Team</span>
                  <span className="block truncate">Penalty</span>
                </p>
              </div>
            )}
          </div>

          <div className="flex gap-4 mt-4">
            <button
              className="px-4 py-2 text-white bg-[#4CAF50] rounded font-semibold disabled:bg-gray-400"
              onClick={onDone}
              disabled={selectedPlayers.length === 0 || submitting}
            >
              {submitting ? 'Saving...' : `Done (${selectedPlayers.length} selected)`}
            </button>
            <button
              className="px-4 py-2 text-black bg-gray-300 rounded font-semibold disabled:bg-gray-200 disabled:text-gray-500"
              onClick={onClose}
              disabled={submitting}
            >
              {submitting ? 'Saving...' : 'Cancel'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PenaltyModal;
